module.exports = __webpack_public_path__ + "static/young-leader-photo-dadrian_ledet-6d1ac7c35afd083d1449fd0479637fec.jpg";